module.exports = __webpack_public_path__ + "img/form_card_bg.1fa262d9.png";